
import { defineComponent, ref, onMounted, computed, inject, watch } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";

interface IndustrySectorsInterface {
  id: number;
}

export default defineComponent({
  name: "IndustrySectors",
  components: {},
  props: {
    formDataTemp: {
      type: Object,
      required: true,
    },
  },
  setup(props, { emit }) {
    const store = useStore();
    const industrySectors = computed(() => store.getters.industrySectorsGetter);
    let formData = ref<Record<string, unknown>>(props.formDataTemp);
    let selectedIndustrySectors = ref<Array<number>>([]);
    const investorProfile = inject("investorProfile");
    watch(
      () => props.formDataTemp,
      () => {
        formData.value = props.formDataTemp;
      }
    );
    watch(investorProfile as Record<string, unknown>, (value) => {
      fetchData(value);
    });
    const fetchData = (value) => {
      for (
        let i = 0;
        i < (value.industrySectors as Array<IndustrySectorsInterface>)?.length ?? 0;
        i++
      ) {
        selectedIndustrySectors.value = [
          ...selectedIndustrySectors.value,
          (value.industrySectors as Array<IndustrySectorsInterface>)[i].id,
        ];
      }
      setTimeout(() => {
      formData.value["industrySectors"] = selectedIndustrySectors.value;
      emit("form-data", formData.value);
      }, 100)
    };
    if ((investorProfile as Record<string, unknown>).value) {
      fetchData((investorProfile as Record<string, unknown>).value);
    }
    const fieldChanged = () => {
      formData.value["industrySectors"] = selectedIndustrySectors.value;
      emit("form-data", formData.value);
    };
    const isSelected = (id) => {
      return selectedIndustrySectors.value.find((is) => is == id);
    };
    const addToIndustrySectors = (event) => {
      if (event.target.checked) {
        selectedIndustrySectors.value = [
          ...selectedIndustrySectors.value,
          event.target.dataset["id"],
        ];
      } else {
        selectedIndustrySectors.value = selectedIndustrySectors.value.filter(
          (i) => {
            return i != event.target.dataset["id"];
          }
        );
      }
      fieldChanged();
    };
    onMounted(async () => {
      if (!industrySectors.value.length)
        await store.dispatch(Actions.GET_INDUSTRY_SECTORS);
    });
    return {
      isSelected,
      formData,
      fieldChanged,
      industrySectors,
      addToIndustrySectors,
      selectedIndustrySectors,
    };
  },
});
